import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { pluralize, capitalize } from 'inflection'

function useSuperAdmin() {
  const event = useSelector(state => state.event.event)

  return useMemo(() => {
    if (event.auction_format === 10) {
      return capitalize(event.event_type_noun || 'item')
    } else {
      return 'Item'
    }
  }, [event.auction_format, event.event_type_noun])
}

export default useSuperAdmin



// WEBPACK FOOTER //
// ./src/hooks/useEventNoun.js